import {
  ChevronDownIcon,
  VideoCameraIcon,
  CollectionIcon,
} from '@heroicons/react/solid';
import { Link } from 'wouter';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSoundcloud } from '@fortawesome/free-brands-svg-icons';

function DropMenu() {
  return (
    <div className="btn-group md:hidden">
      <button
        type="button"
        className="Button rotate-90 duration-500 focus:rotate-0 text-[#f0ffff] border-0 rounded-full border-black p-2"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <ChevronDownIcon className="h-5 w-5" />
      </button>

      {/* Listado de botones */}
      <ul className="dropdown-menu bg-black shadowMarginDropMenu space-y-3 my-3">
        <Link
          to="/genres"
          className="hover:sidebarBtn flex items-center space-x-2 text-red-600  hover:text-[#f0ffff]"
        >
          <CollectionIcon className="h-5 w-5 mr-2 ml-6" />
          <p>Genres</p>
        </Link>
        <Link
          className="hover:sidebarBtn flex items-center space-x-2 text-red-600  hover:text-[#f0ffff]"
          to="/soundcloud"
        >
          <FontAwesomeIcon className="h-5 w-5 mr-2 ml-6" icon={faSoundcloud} />
          <p>SoundCloud</p>
        </Link>
        {/*
        <Link
          to="/residents"
          className="hover:dance mb-3 flex items-center space-x-2 text-red-600  hover:text-white"
        >
          <UserGroupIcon className="h-5 w-5 mr-2 ml-6" />
          <p>Residents</p>
        </Link>
        <Link
          to="/charts"
          className="hover:dance mb-3 flex items-center space-x-2 text-red-600  hover:text-white"
        >
          <FireIcon className="h-5 w-5 mr-2 ml-6" />
          <p>Charts</p>
        </Link>
        <Link
          to="/music"
          className="hover:dance mb-3 flex items-center space-x-2 text-red-600  hover:text-white"
        >
          <MusicNoteIcon className="h-5 w-5 mr-2 ml-6" />
          <p>Music</p>
        </Link>
        <Link
          className="hover:dance mb-3 flex items-center space-x-2 text-red-600  hover:text-white"
          to="/create-playlist"
        >
          <PlusCircleIcon className="h-5 w-5 mr-2 ml-6" />
          <p>Create Playlist</p>
        </Link>
        <Link
          to="/liked-Songs"
          className="hover:dance mb-3 flex items-center space-x-2 text-red-600  hover:text-white"
        >
          <HeartIcon className="h-5 w-5 mr-2 ml-6" />
          <p>Liked Songs</p>
        </Link>*/}
        <Link
          to="/dj-sets"
          className="hover:sidebarBtn flex items-center space-x-2 text-red-600  hover:text-[#f0ffff]"
        >
          <VideoCameraIcon className="h-5 w-5 mr-2 ml-6" />
          <p>DJ Sets</p>
        </Link>
        {/*<Link
          to="/store"
          className="hover:dance mb-3 flex items-center space-x-2 text-red-600  hover:text-white"
        >
          <ShoppingCartIcon className="h-5 w-5 mr-2 ml-6" />
          <p>Store</p>
        </Link>
        <hr className="border-t-[0.5px] border-gray-300" />

        <button
          className="hover:sidebarBtn mb-3 flex items-center space-x-2 text-red-600  hover:text-[#f0ffff]"
          onClick={() => auth.signOut()}
        >
          <LogoutIcon className="h-5 w-5 mr-2 ml-6" />
          <p>Logout</p>
        </button>*/}
      </ul>
    </div>
  );
}

export default DropMenu;
